/** @jsx h */
import { Fragment, h } from 'preact';
import UserDetailsHeader from './UserDetailsHeader';

const CheckoutContentWrapper = (props) => {
  return (
    <Fragment>
      <UserDetailsHeader />
      <div className='innerContentContainer'>{props.children}</div>
    </Fragment>
  );
};

export default CheckoutContentWrapper;



// WEBPACK FOOTER //
// ./components/checkoutWidget/CheckoutContentWrapper.js